var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M89.1204 47.3337L32.8796 12.9632C32.4059 12.6737 31.8636 12.5156 31.3085 12.5052C30.7534 12.4948 30.2056 12.6325 29.7214 12.904C29.2372 13.1756 28.8341 13.5712 28.5535 14.0503C28.2729 14.5293 28.125 15.0745 28.125 15.6296V84.3708C28.125 84.9259 28.2729 85.4711 28.5535 85.9501C28.8341 86.4292 29.2372 86.8248 29.7214 87.0964C30.2056 87.3679 30.7534 87.5056 31.3085 87.4952C31.8636 87.4848 32.4059 87.3267 32.8796 87.0372L89.1204 52.6667C89.5772 52.3875 89.9546 51.9957 90.2165 51.5288C90.4784 51.0619 90.6159 50.5355 90.6159 50.0002C90.6159 49.4649 90.4784 48.9385 90.2165 48.4716C89.9546 48.0047 89.5772 47.6129 89.1204 47.3337Z","stroke":"white","strokeWidth":"6.25","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Play.defaultProps = {"width":"100","height":"100","viewBox":"0 0 100 100","fill":"none"};

module.exports = Play;

Play.default = Play;
